import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { Button, Paper, Grid, FormControl, FormLabel, FormControlLabel, FormGroup, RadioGroup, Radio, Checkbox, TableRow, TableCell, Tooltip, CircularProgress } from '@material-ui/core';
import { ValuationOutPlaceHolder, MaintenaceCondition, BasicDetail, FbvInputs, ValueAsOfCard } from '../../Elements'
import { BvFbvOutput, BvBreadCrumbs, EngineValuationFields, EngineValuationOutput } from '../components';
import { mapFieldGuidance, shopVisitToNumber } from '../mockEngineValuation';
import { PageLoader } from '../../../shared_elements';
import EditIcon from '@material-ui/icons/Edit';
import { getAircraftTypesAc, getEngineTypesAc } from '../../../shared_elements/actionCreators';
import {
  getValuationLogApi,
  getEngineValuationLogApi,
  getEngineValuationFormApi,
  computeEngineValuationApi,
  updateEngineValuationLogApi,
  createValuationLogApi,
  updateValuationLogApi,
  exportValuationLogApi,
  changeLogStatusApi,
} from '../apiServices';
import { buildEngineComputePayload, buildSelectedMetrics, metricsFlagsFromSelection, normalizeEngineComputeResponse } from '../engineValuationMappers';
import { getFleetAssetsApi, getAircraftModsApi, getMntEventsApi, getEnginePRSVEventsApi } from '../../Elements/apiServices';
import { checkApiStatus, removeEmptyKey } from '../../../utils';
import { fieldValidation } from '../../../utils/formValidation';
import { backendDateFormat } from '../../../constants';
import { valuationCrud, errorCode } from '../'
import * as actions from '../../../shared_elements/actions';
import AddIcon from '@material-ui/icons/Add';
const queryString = require('query-string');
class BaseValue extends Component {
  constructor(props) {
    super(props);
    let initialPayload = {};
    if (props.match.params && props.match.params.id) {
      initialPayload = {};
    } else {
      let query = queryString.parse(props.location.search);
      initialPayload = { ...valuationCrud, ...query };
    }
    this.state = {
      skeletonLoader: this.props.match.params.id ? false : true,
      prevMntCond: null,
      pageLoader: false,
      mode: this.props.match.params && this.props.match.params.id ? 'view' : 'add',
      valuationCrud: initialPayload,
      minYear: null,
      maxYear: null,
      error: {},
      mods: [],
      mntGroups: [],
      fleetInfo: {},
      qecOptions: [],
      shopVisitOptions: [],
      conditionNote: '',
      engineOutputReady: false,
      engineFormConfig: null,
      engineFormLoading: false,
      aircraftBootstrapLoaded: false,
    }
    this.getAircraftModsApi = getAircraftModsApi.bind(this);
    this.getValuationLogApi = getValuationLogApi.bind(this);
    this.getEngineValuationLogApi = getEngineValuationLogApi.bind(this);
    this.getEngineValuationFormApi = getEngineValuationFormApi.bind(this);
    this.computeEngineValuationApi = computeEngineValuationApi.bind(this);
    this.updateEngineValuationLogApi = updateEngineValuationLogApi.bind(this);
    this.getMntEventsApi = getMntEventsApi.bind(this);
    this.getEnginePRSVEventsApi = getEnginePRSVEventsApi.bind(this);
    this.createValuationLogApi = createValuationLogApi.bind(this);
    this.updateValuationLogApi = updateValuationLogApi.bind(this);
    this.exportValuationLogApi = exportValuationLogApi.bind(this);
    this.changeLogStatusApi = changeLogStatusApi.bind(this);
    this.getFleetAssetsApi = getFleetAssetsApi.bind(this);
  }
  componentDidMount() {
    const logId = this.props.match.params.id;
    if (logId) {
      // Asset type unknown until log loads — bootstrap aircraft APIs only for aircraft logs
      this.fetchValuationLog('skeletonLoader');
      return;
    }
    // Create flow: load APIs for the initial asset type only
    if (parseInt(this.state.valuationCrud.asset_type, 10) === 2) {
      this.props.getEngineTypes({ valuation: 'valuation', with_bv: true });
      this.fetchEngineFormConfig({ applyDefaults: true });
    } else {
      this.ensureAircraftBootstrap();
    }
  }

  /** Aircraft create/log needs aircraft types + fleet; skip for engine-only screens */
  ensureAircraftBootstrap = () => {
    if (this.state.aircraftBootstrapLoaded) return;
    this.setState({ aircraftBootstrapLoaded: true });
    this.props.getAircraftTypes({ valuation: 'valuation' });
    this.getFleetAssetsApi()
      .then(response => {
        this.setState({ fleetInfo: response });
      });
  }

  applyEngineLogData = (data, formFlags = {}) => {
    const inputs = (data.engine_valuation && data.engine_valuation.inputs) || {};
    const selectedMetrics = inputs.metrics || data.metrics;
    const fromApi = metricsFlagsFromSelection(selectedMetrics);
    // Prefer flags from the just-completed compute navigation; otherwise use saved inputs.metrics
    const flags = {
      show_bv_cmv: formFlags.show_bv_cmv !== undefined ? formFlags.show_bv_cmv : fromApi.show_bv_cmv,
      is_blr_mlr: formFlags.is_blr_mlr !== undefined ? formFlags.is_blr_mlr : fromApi.is_blr_mlr,
      is_future_blr: formFlags.is_future_blr !== undefined ? formFlags.is_future_blr : fromApi.is_future_blr,
      utility_type: formFlags.utility_type != null ? formFlags.utility_type : fromApi.utility_type,
    };
    const normalized = data.engine_valuation
      ? normalizeEngineComputeResponse(data, flags)
      : {
          ...data,
          ...flags,
          date_of_manufacture: data.date_of_manufacture || null,
          projection_to: data.projection_to || null,
          utility_type: flags.utility_type,
          is_blr_mlr: flags.is_blr_mlr,
          is_future_blr: flags.is_future_blr,
          show_bv_cmv: flags.show_bv_cmv,
          condition: data.condition || 'new',
          shop_visit_status: data.shop_visit_status || 'sv1',
        };
    this.setState({
      prevMntCond: 2,
      valuationCrud: normalized,
      mode: 'view',
      engineOutputReady: true,
    }, () => {
      // Engine edit needs engine-type list; form config once (no double fetch)
      this.props.getEngineTypes({ valuation: 'valuation', with_bv: true });
      this.fetchEngineFormConfig({
        applyDefaults: false,
        engineTypeId: normalized.engine_type && normalized.engine_type.id,
      });
    });
  }

  fetchValuationLog = (loaderType = "pageLoader") => {
    this.setState({ pageLoader: true });
    this.setState({ [loaderType]: true });
    this.setState({ error: {} })
    const logId = this.props.match.params.id;
    const formFlags = (this.props.location && this.props.location.state && this.props.location.state.engineFormFlags) || {};

    // Prefer engine-valuation log API; fall back to generic valuation/logs for aircraft
    this.getEngineValuationLogApi(this.props, logId)
      .then(engineResponse => {
        if (checkApiStatus(engineResponse) && engineResponse.data.data && (engineResponse.data.data.asset_type === 2 || engineResponse.data.data.engine_valuation)) {
          this.setState({ pageLoader: false, [loaderType]: false });
          this.applyEngineLogData(Object.assign({}, engineResponse.data.data), formFlags);
          if (this.props.history && this.props.history.replace && this.props.location && this.props.location.state) {
            this.props.history.replace({ pathname: this.props.location.pathname, state: {} });
          }
          return null;
        }
        return this.getValuationLogApi(this.props, logId);
      })
      .then(response => {
        if (!response) return;
        this.setState({ pageLoader: false });
        this.setState({ [loaderType]: false });
        if (checkApiStatus(response)) {
          let data = Object.assign({}, response.data.data);
          if (data.asset_type === 2) {
            this.applyEngineLogData(data, formFlags);
          } else {
            this.ensureAircraftBootstrap();
            this.props.getEngineTypes({ aircraft_type: response.data.data.aircraft_type.id });
            this.getAircraftModsApi(this.props, { aircraft_type: response.data.data.aircraft_type.id })
              .then(response => {
                this.setState({ mods: response });
              });
            this.getMntEventsApi(this.props, data.aircraft_type.id)
              .then(response => {
                this.setState({ mntGroups: response })
              });
            let maxY, minY;
            if (Object.keys(response.data.data.future_value)[0]) {
              minY = Object.keys(response.data.data.future_value)[0];
            } else {
              minY = '0000';
            }
            if (Object.keys(response.data.data.future_value)[Object.keys(response.data.data.future_value).length - 1]) {
              maxY = Object.keys(response.data.data.future_value)[Object.keys(response.data.data.future_value).length - 1]
            } else {
              maxY = '0000';
            }
            this.setState({ minYear: minY.slice(0, 4), maxYear: maxY.slice(0, 4) })
            if (data.is_full_life_maintenance_condition) {
              this.getEnginePRSVEventsApi(this.props, data.aircraft_type.id, data.engine_type.id)
                .then(response => {
                  let oldEngines = data.engine_sv_details;
                  if (checkApiStatus(response)) {
                    let newEngines = {}
                    if (data.engine_sv_details && data.engine_sv_details.length) {
                      newEngines = {
                        no_of_engines: data.engine_sv_details.length,
                        is_propeller_aircraft: false,
                        engines: response.data.data.engines.map((item, index) => oldEngines[index] ? oldEngines[index] : item)
                      };
                    } else {
                      newEngines = response.data.data;
                    }
                    data = {
                      ...data,
                      mtow_kgs: (data.mtow * 0.4535970244).toFixed(4),
                      engine_sv_details: newEngines,
                      utility_type: data.future_value && Object.keys(data.future_value).length ? 2 : 1,
                    }
                    this.setState({ prevMntCond: data.is_full_life_maintenance_condition, valuationCrud: data, mode: 'view' });
                  }
                })
            } else {
              data = {
                ...data,
                utility_type: data.future_value && Object.keys(data.future_value).length ? 2 : 1,
                mtow_kgs: (response.data.data.mtow * 0.4535970244).toFixed(4)
              }
              this.setState({ prevMntCond: data.is_full_life_maintenance_condition, valuationCrud: data, mode: 'view' });
            }
          }
        } else {
          this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          this.props.history.push('/logs');
        }
      })
      .catch(() => {
        this.setState({ pageLoader: false, [loaderType]: false });
        this.props.enqueueSnackbar('Unable to fetch valuation log.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        this.props.history.push('/logs');
      })
  }

  fetchEngineFormConfig = ({ applyDefaults = true, engineTypeId } = {}) => {
    const query = engineTypeId ? { engine_type_id: engineTypeId } : {};
    this.setState({ engineFormLoading: true });
    return this.getEngineValuationFormApi(query)
      .then(response => {
        this.setState({ engineFormLoading: false });
        if (checkApiStatus(response)) {
          this.applyEngineFormConfig(response.data.data, { applyDefaults });
          return response.data.data;
        }
        return null;
      })
      .catch(() => {
        this.setState({ engineFormLoading: false });
        return null;
      });
  }

  resolveQecOption = (qecType, qecOptions = []) => {
    if (!qecOptions.length) return null;
    if (!qecType) return null;
    const id = typeof qecType === 'object' ? (qecType.id != null ? qecType.id : qecType.value) : qecType;
    return qecOptions.find(o => o.id === id || o.value === id) || null;
  }

  applyEngineFormConfig = (formData, { applyDefaults = true } = {}) => {
    if (!formData) return;
    const defaults = formData.defaults || {};
    const metrics = formData.metrics || [];
    const metricDefault = (key) => {
      const m = metrics.find(item => item.key === key);
      return m ? !!m.default : undefined;
    };
    const apiQec = Array.isArray(formData.qec_options) ? formData.qec_options : [];
    const apiShopVisit = Array.isArray(formData.shop_visit_options) ? formData.shop_visit_options : [];

    this.setState(prevState => {
      const nextCrud = { ...prevState.valuationCrud };
      if (applyDefaults) {
        if (defaults.inflation_rate != null) nextCrud.escalation_percentage = defaults.inflation_rate;
        if (defaults.qec_discount != null) nextCrud.qec_discount = defaults.qec_discount;
        if (defaults.premium_for_new != null) nextCrud.premium_for_new = defaults.premium_for_new;
        if (defaults.premium_percentage != null) nextCrud.premium_pct = defaults.premium_percentage;
        if (defaults.condition != null) nextCrud.condition = defaults.condition;
        if (defaults.shop_visit_status != null) {
          nextCrud.shop_visit_status = typeof defaults.shop_visit_status === 'object'
            ? (defaults.shop_visit_status.code || defaults.shop_visit_status.value)
            : defaults.shop_visit_status;
        }
        if (defaults.qec_type != null) {
          nextCrud.qec_type = this.resolveQecOption(defaults.qec_type, apiQec) || defaults.qec_type;
        } else if (apiQec.length && !nextCrud.qec_type) {
          nextCrud.qec_type = null;
        }
        if (defaults.engine_type != null) nextCrud.engine_type = defaults.engine_type;
        const bvDefault = metricDefault('bv_cmv');
        const fbvDefault = metricDefault('fbv');
        const blrDefault = metricDefault('blr');
        const fblrDefault = metricDefault('fblr');
        if (bvDefault !== undefined) nextCrud.show_bv_cmv = bvDefault;
        if (fbvDefault !== undefined) nextCrud.utility_type = fbvDefault ? 2 : 1;
        if (blrDefault !== undefined) nextCrud.is_blr_mlr = blrDefault;
        if (fblrDefault !== undefined) nextCrud.is_future_blr = fblrDefault;
      } else if (nextCrud.qec_type) {
        nextCrud.qec_type = this.resolveQecOption(nextCrud.qec_type, apiQec) || nextCrud.qec_type;
      }
      if (!apiQec.length) nextCrud.qec_type = null;
      return {
        ...prevState,
        engineFormConfig: formData,
        qecOptions: apiQec,
        shopVisitOptions: apiShopVisit,
        valuationCrud: nextCrud,
      };
    });
  }

  applyEngineTypeConfig = (engineType, { applyDefaults = true } = {}) => {
    if (engineType && engineType.id) {
      this.fetchEngineFormConfig({ applyDefaults, engineTypeId: engineType.id });
      return;
    }
    // No engine type: refresh base form config (options may be empty until type is chosen)
    this.fetchEngineFormConfig({ applyDefaults });
  }

  validateConditionVsShopVisit = (condition, shopVisitStatus) => {
    const { engineFormConfig } = this.state;
    const rules = (engineFormConfig && engineFormConfig.condition_rules) || {};
    const svNum = shopVisitToNumber(shopVisitStatus);
    let nextCondition = condition;
    let conditionNote = '';
    if (svNum != null && (rules.block_new_when_shop_visit_in || []).includes(svNum) && condition === 'new') {
      nextCondition = 'used';
      conditionNote = rules.block_message || '';
    } else if (svNum != null && (rules.remind_when_used_on_shop_visit_in || []).includes(svNum) && condition === 'used') {
      conditionNote = rules.remind_message || '';
    }
    return { nextCondition, conditionNote };
  }

  onChangeEvents = (e, keyParam, value, index) => {
    if (keyParam === 'no_of_engines') {
      this.setState(prevState => ({
        ...prevState,
        valuationCrud: {
          ...prevState.valuationCrud,
          engine_sv_details: {
            ...prevState.valuationCrud.engine_sv_details,
            no_of_engines: value
          }
        }
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        valuationCrud: {
          ...prevState.valuationCrud,
          engine_sv_details: {
            ...prevState.valuationCrud.engine_sv_details,
            engines: prevState.valuationCrud.engine_sv_details.engines.map((engine, engineIndex) => engineIndex === index ? { ...engine, [keyParam]: value } : engine)
          }
        }
      }))
    }
  }
  onChangeEngineMods = (e, keyParam, value, index, modeType) => {
    if (modeType === 'edit') {
      this.setState(prevState => ({
        ...prevState,
        valuationCrud: {
          ...prevState.valuationCrud,
          engine_mods: prevState.valuationCrud.engine_mods.map((item, itemIndex) => itemIndex === index ? { ...item, [keyParam]: value } : item)
        }
      }))
    }
    if (modeType === 'add') {
      this.setState(prevState => ({
        ...prevState,
        valuationCrud: {
          ...prevState.valuationCrud,
          engine_mods: [...prevState.valuationCrud.engine_mods, { name: '', value: '' }]
        }
      }))
    }
    if (modeType === 'delete') {
      this.setState(prevState => ({
        ...prevState,
        valuationCrud: {
          ...prevState.valuationCrud,
          engine_mods: prevState.valuationCrud.engine_mods.filter((item, itemIndex) => itemIndex !== index)
        }
      }))
    }
  }
  onChangeSerialNo = (e, keyParam, value) => {
    const { aircraftTypes } = this.props;
    this.setState(prevState => ({
      ...prevState,
      valuationCrud: {
        ...prevState.valuationCrud,
        engine_type: value ? value.engine_type:null,
        mtow_kgs:value ? value.mtow:'',
        mtow:value ?(value.mtow * 2.2046).toFixed(4):'',
        date_of_manufacture:value ? value.date_of_manufacture:null,
        serial_number:value ? value.serial_number:'',
        aircraft_type:value ? aircraftTypes.find(item => item.id === value.aircraft_type.id):null
      }
    }));
    if(value){
      this.getAircraftModsApi(this.props, { aircraft_type: value.aircraft_type.id })
      .then(response => {
        this.setState({ mods: response });
      })
      this.getMntEventsApi(this.props, value.aircraft_type.id)
      .then(response => {
        this.setState({ mntGroups: response })
      })
      this.props.getEngineTypes({ aircraft_type: value.aircraft_type.id, valuation: 'valuation' })
    }else{
      this.setState({ mods: [], mntGroups: [] });
      this.props.clearEngineTypes();
    }
  }
  onFieldChange = (e, keyParam, value) => {
    const { valuationCrud } = this.state;
    if (keyParam === 'condition' || keyParam === 'shop_visit_status') {
      const nextCondition = keyParam === 'condition' ? value : valuationCrud.condition;
      const nextSv = keyParam === 'shop_visit_status' ? value : valuationCrud.shop_visit_status;
      const { nextCondition: validatedCondition, conditionNote } = this.validateConditionVsShopVisit(nextCondition, nextSv);
      this.setState(prevState => ({
        ...prevState,
        conditionNote,
        valuationCrud: {
          ...prevState.valuationCrud,
          condition: validatedCondition,
          shop_visit_status: nextSv,
        },
      }));
      return;
    }
    if (keyParam === 'is_future_blr' && value) {
      this.updateFormFields('is_blr_mlr', true);
    }
    this.updateFormFields(keyParam, value);
    if (keyParam === 'engine_type' && valuationCrud.asset_type === 2) {
      this.applyEngineTypeConfig(value, { applyDefaults: true });
    }
    if (keyParam === 'asset_type') {
      this.setState(prevState => ({
        ...prevState,
        error: {},
        engineOutputReady: false,
        conditionNote: '',
        engineFormConfig: null,
        qecOptions: [],
        shopVisitOptions: [],
        valuationCrud: {
          ...prevState.valuationCrud,
          is_global_msn: null,
          serial_number: '',
          mtow: '',
          mtow_kgs: '',
          date_of_manufacture: null,
          engine_type: null,
          aircraft_type: null,
          // Engine field defaults come only from form API (fetch below)
          ...(value === 2 ? {
            is_full_life_maintenance_condition: 2,
            condition: null,
            shop_visit_status: null,
            qec_type: null,
            escalation_percentage: null,
            premium_for_new: null,
            premium_pct: null,
            qec_discount: null,
            show_bv_cmv: null,
            utility_type: null,
            is_blr_mlr: null,
            is_future_blr: null,
          } : {}),
        }
      }));
      this.props.clearEngineTypes();
      if (value === 2) {
        this.props.getEngineTypes({ valuation: 'valuation', 'with_bv': true });
        this.fetchEngineFormConfig({ applyDefaults: true });
      } else {
        // Engine → Aircraft on create: ensure aircraft APIs are available
        this.ensureAircraftBootstrap();
        if (valuationCrud.aircraft_type && valuationCrud.aircraft_type.id) {
          this.props.getEngineTypes({ aircraft_type: valuationCrud.aircraft_type.id, valuation: 'valuation' })
        }
      }
    }
    if (keyParam === 'aircraft_type') {
      this.updateFormFields('mods', []);
      this.updateFormFields('maintenance_program', null);
      this.updateFormFields('engine_type', null);
      if (value) {
        this.getAircraftModsApi(this.props, { aircraft_type: value.id })
          .then(response => {
            this.setState({ mods: response });
          })
        this.getMntEventsApi(this.props, value.id)
          .then(response => {
            this.setState({ mntGroups: response })
          })
        this.props.getEngineTypes({ aircraft_type: value.id, valuation: 'valuation' })
      } else {
        this.setState({ mods: [], mntGroups: [] })
      }
    }
    if ((keyParam === 'mtow' || keyParam === 'mtow_kgs') && value >= 0) {
      if (keyParam == 'mtow_kgs') {
        this.updateFormFields('mtow', (value * 2.2046).toFixed(4));
      } else {
        this.updateFormFields('mtow_kgs', (value * 0.4535970244).toFixed(4));
      }
    }
    if (keyParam === 'date_of_manufacture') {
      this.updateFormFields('base_value_date', null);
    }
    if (keyParam === 'is_full_life_maintenance_condition') {
      if (valuationCrud.asset_type && valuationCrud.asset_type === 1) {
        if (value) {
          this.getEnginePRSVEventsApi(this.props, valuationCrud.aircraft_type.id, valuationCrud.engine_type.id)
            .then(response => {
              if (checkApiStatus(response)) {
                this.setState(prevState => ({
                  ...prevState,
                  valuationCrud: {
                    ...prevState.valuationCrud,
                    engine_sv_details: response.data.data
                  }
                }))
              }
            })
        } else {
          this.updateFormFields('engine_sv_details', []);
        }
      }
    }
    if (['aircraft_type', 'engine_type'].includes(keyParam)) {
      this.updateFormFields('is_full_life_maintenance_condition', 0);
      this.updateFormFields('engine_sv_details', null);
    }
    if(keyParam === 'is_global_msn'){
      if(!value){
        this.props.clearEngineTypes();
      }
      this.setState(prevState => ({
        ...prevState,
        valuationCrud: {
          ...prevState.valuationCrud,
          serial_number: '',
          mtow:'',
          mtow_kgs:'',
          date_of_manufacture:null,
          engine_type:null,
          aircraft_type:null
        }
      }));
    }
  }
  updateFormFields = (key, value) => {
    this.setState(prevState => ({
      ...prevState,
      valuationCrud: {
        ...prevState.valuationCrud,
        [key]: value
      }
    }));
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  createValuationFn = () => {
    const { valuationCrud } = this.state;
    let validationInputs = {};
    if (valuationCrud.asset_type === 1) {
      validationInputs = {
        aircraft_type: errorCode['aircraft_type'][fieldValidation({ ...errorCode['aircraft_typeObj'], fieldval: valuationCrud.aircraft_type })],
        serial_number: errorCode['serial_number'][fieldValidation({ ...errorCode['serial_numberObj'], fieldval: valuationCrud.serial_number })],
        date_of_manufacture: errorCode['date_of_manufacture'][fieldValidation({ ...errorCode['date_of_manufactureObj'], fieldval: valuationCrud.date_of_manufacture })],
        engine_type: errorCode['engine_type'][fieldValidation({ ...errorCode['engine_typeObj'], fieldval: valuationCrud.engine_type })],
        mtow: errorCode['mtow'][fieldValidation({ ...errorCode['mtowObj'], fieldval: valuationCrud.mtow })],
        mtow_kgs: errorCode['mtow_kgs'][fieldValidation({ ...errorCode['mtow_kgsObj'], fieldval: valuationCrud.mtow_kgs })],
        base_value_date: errorCode['base_value_date'][fieldValidation({ ...errorCode['base_value_dateObj'], fieldval: valuationCrud.base_value_date })],
        projection_to: parseInt(valuationCrud.utility_type) !== 1 ? errorCode['projection_to'][fieldValidation({ ...errorCode['projection_toObj'], fieldval: valuationCrud.projection_to })] : '',
        maintenance_program: valuationCrud.is_full_life_maintenance_condition !== 0 ? errorCode['maintenance_program'][fieldValidation({ ...errorCode['maintenance_programObj'], fieldval: valuationCrud.maintenance_program })] : '',
        escalation_percentage: parseInt(valuationCrud.utility_type) !== 1 ? valuationCrud.escalation_percentage && valuationCrud.escalation_percentage?.toString().trim().length ? parseFloat(valuationCrud.escalation_percentage) >= 1 && parseFloat(valuationCrud.escalation_percentage) <= 5 ? '':'Value should be b/w 1 to 5' :'Please enter Escalation Percentage'  : ''
      }
    } else {
      const selectedMetrics = buildSelectedMetrics(valuationCrud);
      const needsProjection = selectedMetrics.includes('fbv') || selectedMetrics.includes('fblr');
      const formConfig = this.state.engineFormConfig || {};
      const qecRequired = !!formConfig.qec_required;
      const shopVisitRequired = formConfig.shop_visit_required !== false;
      const inflationDefaults = formConfig.defaults || {};
      const inflationMin = inflationDefaults.inflation_rate_min != null ? Number(inflationDefaults.inflation_rate_min) : null;
      const inflationMax = inflationDefaults.inflation_rate_max != null ? Number(inflationDefaults.inflation_rate_max) : null;
      const inflationVal = valuationCrud.escalation_percentage !== null && valuationCrud.escalation_percentage !== undefined
        ? valuationCrud.escalation_percentage.toString().trim()
        : '';
      const inflationNum = inflationVal !== '' ? parseFloat(inflationVal) : NaN;
      let inflationError = '';
      if (!inflationVal.length) {
        inflationError = 'Please enter Inflation Rate';
      } else if (inflationMin != null && inflationMax != null && (Number.isNaN(inflationNum) || inflationNum < inflationMin || inflationNum > inflationMax)) {
        inflationError = `Value should be between ${inflationMin.toFixed(1)}% to ${inflationMax.toFixed(1)}%`;
      }
      validationInputs = {
        engine_type: errorCode['engine_type'][fieldValidation({ ...errorCode['engine_typeObj'], fieldval: valuationCrud.engine_type })],
        base_value_date: errorCode['base_value_date'][fieldValidation({ ...errorCode['base_value_dateObj'], fieldval: valuationCrud.base_value_date })],
        shop_visit_status: shopVisitRequired
          ? (valuationCrud.shop_visit_status ? '' : errorCode['shop_visit_status'][1])
          : '',
        condition: valuationCrud.condition ? '' : errorCode['condition'][1],
        qec_type: qecRequired ? (valuationCrud.qec_type ? '' : errorCode['qec_type'][1]) : '',
        projection_to: (() => {
          if (!needsProjection) return '';
          const raw = valuationCrud.projection_to;
          if (raw === null || raw === undefined || !raw.toString().trim().length) {
            return errorCode['projection_to'][1];
          }
          const proj = moment(raw, backendDateFormat, true).isValid()
            ? moment(raw, backendDateFormat, true)
            : moment(raw);
          if (!proj.isValid()) {
            return errorCode['projection_to'][5];
          }
          // Must be a future date (not today / past)
          if (proj.clone().startOf('day').diff(moment().startOf('day'), 'days') <= 0) {
            return 'Projection date must be a future date';
          }
          return '';
        })(),
        escalation_percentage: inflationError,
      }
    }
    if (valuationCrud.base_value_date) {
      if (valuationCrud.asset_type === 2) {
        validationInputs = {
          ...validationInputs,
          base_value_date: moment(valuationCrud.base_value_date).isBetween(moment().startOf('year').subtract(1, 'day'), moment().endOf('year')) ? '' : 'Value as of date should be in current year'
        }
      } else {
        validationInputs = {
          ...validationInputs,
          base_value_date: moment(valuationCrud.base_value_date).isBetween(moment().subtract(1, 'year').subtract(1, 'day'), moment().endOf('year')) ? '' : `Value as of date should be in current year or previous year`
        }
      }
    }

    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
      let payload = Object.assign({}, valuationCrud);
      delete payload.mtow_kgs;
      const needsProjection = valuationCrud.asset_type === 2
        ? (parseInt(valuationCrud.utility_type) === 2 || valuationCrud.is_future_blr)
        : parseInt(valuationCrud.utility_type) !== 1;
      if (!needsProjection) {
        delete payload.projection_to
        delete payload.projection_from
        delete payload.escalation_percentage
      } else {
        if (payload.projection_to) {
          payload = {
            ...payload,
            projection_from: payload.base_value_date,
          }
        }
      }
      if (valuationCrud.asset_type === 1) {
        if (payload.mods.length) {
          payload = {
            ...payload,
            mods: valuationCrud.mods.map(mod => mod.id)
          }
        }
        if (payload.is_full_life_maintenance_condition) {
          payload = {
            ...payload,
            engine_sv_details: valuationCrud.engine_sv_details.engines.slice(0, valuationCrud.engine_sv_details.no_of_engines)
          }
          if (payload.maintenance_program) {
            payload = {
              ...payload,
              maintenance_program: valuationCrud.maintenance_program.value
            }
          }
        }
      }
      if (valuationCrud.asset_type === 2) {
        const enginePayload = buildEngineComputePayload(valuationCrud);
        const formFlags = {
          show_bv_cmv: valuationCrud.show_bv_cmv,
          is_blr_mlr: valuationCrud.is_blr_mlr,
          is_future_blr: valuationCrud.is_future_blr,
          utility_type: valuationCrud.utility_type,
        };
        if (this.props.match.params && this.props.match.params.id) {
          // Edit existing engine log
          this.updateEngineValuationLogApi(this.props, enginePayload, formFlags, this.fetchValuationLog);
        } else {
          // Create new engine log
          this.computeEngineValuationApi(this.props, enginePayload, formFlags);
        }
        return;
      }

      if ((payload.utility_type in [1, 2]) && (payload.is_full_life_maintenance_condition) && payload.asset_type !== 2) {
        if (payload.base_value_date.includes('2022-')) {
          this.props.enqueueSnackbar('Full life calculation not available for 2022 Year', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
        else {
          if (this.props.match.params && this.props.match.params.id) {
            this.updateValuationLogApi(this.props, payload, this.fetchValuationLog);
          } else {
            this.createValuationLogApi(this.props, payload);
          }
        }
      }
      else {
        if (this.props.match.params && this.props.match.params.id) {
          this.updateValuationLogApi(this.props, payload, this.fetchValuationLog);
        } else {
          this.createValuationLogApi(this.props, payload);
        }
      }
    } else {
      let target = Object.keys(removeEmptyKey(validationInputs))[0];
      if (this.props.match.params.id) {
        window.location.href = `/logs/${this.props.match.params.id}#${target}`;
      } else {
        window.location.href = `/logs/create${this.props.location.search}#${target}`;
      }
      this.setState({ error: validationInputs });
    }
  }
  render() {
    const {
      fleetInfo, prevMntCond, pageLoader, mode, valuationCrud, error, mods, mntGroups,
      minYear, maxYear, skeletonLoader, qecOptions, shopVisitOptions, conditionNote,
      engineOutputReady, engineFormConfig, engineFormLoading,
    } = this.state;
    const { aircraftTypes, engineTypes } = this.props;
    const isEngine = valuationCrud.asset_type === 2;
    const engineMetrics = (engineFormConfig && engineFormConfig.metrics) || [];
    const metricMeta = (key) => engineMetrics.find(m => m.key === key) || {};
    const isMetricDefault = (key) => !!metricMeta(key).default;
    // Lock form-config defaults only on create; saved logs must reflect inputs.metrics
    const lockMetricDefault = (key) => isEngine && isMetricDefault(key) && !this.props.match.params.id;
    const metricLabel = (key, fallback) => {
      const m = metricMeta(key);
      const label = m.label || fallback;
      return m.default ? (
        <Fragment>{label}<sup style={{ fontSize: '9px', color: '#3f51b5' }}>(DEFAULT)</sup></Fragment>
      ) : label;
    };
    const conditionOptions = (engineFormConfig && Array.isArray(engineFormConfig.conditions))
      ? engineFormConfig.conditions
      : [];
    const fieldGuidance = mapFieldGuidance((engineFormConfig && engineFormConfig.field_guidance) || {});
    const inflationDefaults = (engineFormConfig && engineFormConfig.defaults) || {};
    const inflationRateMin = inflationDefaults.inflation_rate_min;
    const inflationRateMax = inflationDefaults.inflation_rate_max;
    return (
      <section className="valuation-app-section">
        <BvBreadCrumbs skeletonLoader={skeletonLoader} changeLogStatus={(data) => this.changeLogStatusApi(this.props, data)} logResult={valuationCrud} mode={mode} onChangeMode={() => this.setState(prevState => ({ ...prevState, mode: mode === 'view' ? 'edit' : 'view' }))} exportValuationLog={(file) => this.exportValuationLogApi(this.props, file, valuationCrud)} />
        <Grid container spacing={1}>
          <Grid item md={8} sm={8} xs={12}>
            <Paper className="add-bv-fbv-form">
              <div style={{ maxHeight: `${window.innerHeight - 195}px`, overflow: 'auto', padding: '10px 15px', position: 'relative' }}>
                {isEngine && engineFormLoading ? (
                  <div className="engine-form-loading-overlay">
                    <CircularProgress size={36} color="primary" />
                    <span>Loading form config…</span>
                  </div>
                ) : null}
                {
                  !valuationCrud.lock_status && mode === 'view' && !skeletonLoader ? <span onClick={() => this.setState({ mode: 'edit' })} className="edit-icon">
                    <Tooltip arrow title='Edit' placement='top'>
                    <EditIcon color="primary" fontSize="small" />
                    </Tooltip>
                    </span> : null
                }
                <form className={`form${isEngine && engineFormLoading ? ' engine-form-loading' : ''}`}>
                  <Grid container spacing={1}>
                    <Grid item md={12} xs={12}>
                      <div className="select-utils-type">
                        <div className="util-card flex-centered" style={{ marginTop: '15px', flexWrap: 'wrap' }}>
                          <FormControl component="fieldset">
                            <FormGroup aria-label="position" row>
                              {isEngine ? (
                                <FormControlLabel
                                  disabled={mode === 'view'}
                                  control={
                                    <Checkbox
                                      style={lockMetricDefault('bv_cmv') ? { cursor: 'disabled' } : undefined}
                                      checked={valuationCrud.show_bv_cmv !== false}
                                      onChange={lockMetricDefault('bv_cmv') ? undefined : (e) => this.onFieldChange(e, 'show_bv_cmv', e.target.checked)}
                                      color="primary"
                                    />
                                  }
                                  label={metricLabel('bv_cmv', 'BV and CMV')}
                                  labelPlacement="end"
                                />
                              ) : (
                                <FormControlLabel
                                  disabled={mode === 'view'}
                                  value="end"
                                  control={<Checkbox style={{ cursor: 'disabled' }} checked color="primary" />}
                                  label={<Fragment>BV and CMV<sup style={{ fontSize: '9px', color: '#3f51b5' }}>(DEFAULT)</sup></Fragment>}
                                  labelPlacement="end"
                                />
                              )}
                              <FormControlLabel
                                disabled={mode === 'view'}
                                value="end"
                                control={
                                  <Checkbox
                                    style={lockMetricDefault('fbv') ? { cursor: 'disabled' } : undefined}
                                    onChange={lockMetricDefault('fbv') ? undefined : (e) => this.onFieldChange(e, 'utility_type', e.target.checked ? 2 : 1)}
                                    checked={((parseInt(valuationCrud.utility_type) === 2) || (valuationCrud.utility_type == 'Future Value')) ? true : false}
                                    color="primary"
                                  />
                                }
                                label={isEngine ? metricLabel('fbv', 'FBV') : 'FBV'}
                                labelPlacement="end"
                              />
                              {isEngine ? (
                                <Fragment>
                                  <FormControlLabel
                                    disabled={mode === 'view'}
                                    control={
                                      <Checkbox
                                        style={lockMetricDefault('blr') ? { cursor: 'disabled' } : undefined}
                                        checked={!!valuationCrud.is_blr_mlr}
                                        onChange={lockMetricDefault('blr') ? undefined : (e) => this.onFieldChange(e, 'is_blr_mlr', e.target.checked)}
                                        color="primary"
                                      />
                                    }
                                    label={metricLabel('blr', 'BLR')}
                                    labelPlacement="end"
                                  />
                                  <FormControlLabel
                                    disabled={mode === 'view'}
                                    control={
                                      <Checkbox
                                        style={lockMetricDefault('fblr') ? { cursor: 'disabled' } : undefined}
                                        checked={!!valuationCrud.is_future_blr}
                                        onChange={lockMetricDefault('fblr') ? undefined : (e) => this.onFieldChange(e, 'is_future_blr', e.target.checked)}
                                        color="primary"
                                      />
                                    }
                                    label={metricLabel('fblr', 'FBLR')}
                                    labelPlacement="end"
                                  />
                                </Fragment>
                              ) : null}
                            </FormGroup>
                          </FormControl>
                          <div className='flex-centered' style={{ marginLeft: 'auto' }}>
                            <span style={{ paddingRight: '10px', fontSize: '15px' }}><b>Asset Type:</b></span>
                            <FormControl component="fieldset" disabled={this.props.match.params.id ? true : false}>
                              <RadioGroup row aria-label="asset_type" name="asset_type">
                                <FormControlLabel
                                  value="asset_type"
                                  control={<Radio size="small" onClick={(e) => this.onFieldChange(e, 'asset_type', 1)} checked={valuationCrud.asset_type === 1 ? true : false} color="primary" />}
                                  label="Aircraft"
                                  labelPlacement="end"
                                />
                                <FormControlLabel
                                  value="asset_type"
                                  control={<Radio size="small" onClick={(e) => this.onFieldChange(e, 'asset_type', 2)} checked={valuationCrud.asset_type === 2 ? true : false} color="primary" />}
                                  label="Engine"
                                  labelPlacement="end"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>

                      </div>
                    </Grid>

                    {isEngine ? (
                      <EngineValuationFields
                        mode={mode}
                        error={error}
                        valuationCrud={valuationCrud}
                        onFieldChange={this.onFieldChange}
                        updateErrorField={this.updateErrorField}
                        engineTypes={engineTypes}
                        qecOptions={qecOptions}
                        shopVisitOptions={shopVisitOptions}
                        conditionOptions={conditionOptions}
                        fieldGuidance={fieldGuidance}
                        conditionNote={conditionNote}
                        inflationRateMin={inflationRateMin}
                        inflationRateMax={inflationRateMax}
                      />
                    ) : (
                      <Fragment>
                        <BasicDetail
                          mode={mode}
                          crudData={valuationCrud}
                          onFieldChange={this.onFieldChange}
                          onChangeSerialNo={this.onChangeSerialNo}
                          updateErrorField={this.updateErrorField}
                          error={error}
                          mods={mods}
                          aircraftTypes={aircraftTypes}
                          engineTypes={engineTypes}
                          fleetInfo={fleetInfo}
                        />
                        <MaintenaceCondition
                          mode={mode}
                          error={error}
                          maintenaceObj={valuationCrud}
                          onFieldChange={this.onFieldChange}
                          updateErrorField={this.updateErrorField}
                          onChangeEvents={this.onChangeEvents}
                          mntGroups={mntGroups}
                        />
                        {parseInt(valuationCrud.utility_type) === 2 ?
                          <FbvInputs
                            mode={mode}
                            valuationCrud={valuationCrud}
                            onFieldChange={this.onFieldChange}
                            updateErrorField={this.updateErrorField}
                            error={error}
                            minYear={minYear}
                            maxYear={maxYear}
                          /> : null
                        }
                      </Fragment>
                    )}

                  </Grid>
                </form>
              </div>
              <ValueAsOfCard
                mode={mode}
                error={error}
                onFieldChange={this.onFieldChange}
                updateErrorField={this.updateErrorField}
                logResult={valuationCrud}
                onSubmit={this.createValuationFn}
                onCancel={this.fetchValuationLog}
              />
            </Paper>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <div style={{ maxHeight: `${window.innerHeight - 110}px`, overflow: 'auto' }}>
              {isEngine ? (
                engineOutputReady && Object.keys(valuationCrud).length ?
                  <EngineValuationOutput logResult={valuationCrud} /> :
                  <ValuationOutPlaceHolder />
              ) : (
                this.props.match.params.id && Object.keys(valuationCrud).length && prevMntCond !== null ?
                  <BvFbvOutput prevMntCond={prevMntCond} logResult={valuationCrud} minYear={minYear} maxYear={maxYear} /> :
                  <ValuationOutPlaceHolder />
              )}
            </div>
          </Grid>
        </Grid>
        {pageLoader ? <PageLoader /> : null}
      </section>
    )
  }
}
const mapStateToProps = state => ({
  engineTypes: state.shareReducer.engineTypes,
  aircraftTypes: state.shareReducer.aircraftTypes,
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getAircraftTypes: () => dispatch(getAircraftTypesAc(ownProps, { valuation: 'valuation' })),
    getEngineTypes: (query) => dispatch(getEngineTypesAc(query)),
    clearEngineTypes: () => dispatch({ type: actions.ENGINE_TYPES, payload: [] })
  }
}
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(BaseValue))
